module.exports = __webpack_public_path__ + "static/media/le-malin-icon.92a84e9d.png";